export default __webpack_public_path__ + "static/media/feature1.e7c9ab59.svg";